import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import { fadeUp, viewport } from "@/lib/motion";
import { TESTIMONIALS } from "@/lib/data";

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = TESTIMONIALS[idx];
  const go = (dir) => setIdx((p) => (p + dir + TESTIMONIALS.length) % TESTIMONIALS.length);

  return (
    <section id="stories" data-testid="testimonials-section" className="py-24 md:py-36 bg-[hsl(var(--muted)/0.4)]">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}
          className="text-xs font-semibold tracking-[0.25em] uppercase text-gold mb-10">Success Stories</motion.p>

        <Quote className="text-[hsl(var(--gold)/0.5)] mb-8" size={48} strokeWidth={1} />

        <div className="min-h-[220px] md:min-h-[240px]">
          <AnimatePresence mode="wait">
            <motion.blockquote key={idx}
              initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              data-testid="testimonial-quote">
              <p className="font-serif font-light text-3xl md:text-4xl lg:text-5xl leading-tight text-primary">
                "{t.quote}"
              </p>
              <footer className="mt-8">
                <p className="font-medium text-primary">{t.name}</p>
                <p className="text-sm text-muted-foreground">{t.org}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center gap-4">
          <button data-testid="testimonial-prev" onClick={() => go(-1)}
            className="grid place-items-center w-12 h-12 rounded-full border border-primary/25 text-primary hover:bg-primary hover:text-primary-foreground transition-colors">
            <ArrowLeft size={18} />
          </button>
          <button data-testid="testimonial-next" onClick={() => go(1)}
            className="grid place-items-center w-12 h-12 rounded-full border border-primary/25 text-primary hover:bg-primary hover:text-primary-foreground transition-colors">
            <ArrowRight size={18} />
          </button>
          <span className="ml-3 text-sm text-muted-foreground">{idx + 1} / {TESTIMONIALS.length}</span>
        </div>
      </div>
    </section>
  );
};
